// extracted by mini-css-extract-plugin
export default {"content_page":"medlem_content_page__PIGIK","mail":"medlem_mail__XYIxa"};